<template>
  <header class="header">
    <div class="logo-container">
      <!-- <router-link to="/" class="logo"> ALL ASIAN MASSAGE 6 </router-link> -->
      <router-link to="/" class="logo">MASSAGE </router-link>
    </div>
    <nav class="nav-container">
      <el-menu
        :default-active="activeIndex"
        class="nav-menu"
        mode="horizontal"
        router
        background-color="transparent"
        text-color="#333"
        active-text-color="#e9a750"
      >
        <el-menu-item index="/">HOME</el-menu-item>
        <el-menu-item index="/about">ABOUT US</el-menu-item>
        <el-menu-item index="/services">SERVICES</el-menu-item>
        <el-menu-item index="/gallery">GALLERY</el-menu-item>
        <el-menu-item index="/contact">CONTACT</el-menu-item>
        <!-- <el-menu-item index="book-now">
          <a
            href="http://fresha.com/book-now/all-asian-massage-6-neg81tbo/services"
            target="_blank"
            rel="noopener noreferrer"
          >
            BOOK NOW
          </a>
        </el-menu-item> -->
      </el-menu>
    </nav>
  </header>
</template>

<script>
export default {
  name: "HeaderComponent",
  computed: {
    activeIndex() {
      return this.$route.path
    },
  },
}
</script>

<style scoped>
.header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--dark-bg-color);
  color: var(--primary-color);
  padding: 1rem 2rem;
}

.logo-container {
  padding: 0;
  margin-bottom: 0;
}

.logo {
  font-size: 2rem;
  font-weight: bold;
  color: var(--primary-color);
  text-decoration: none;
  display: inline-block;
}

.nav-container {
  display: flex;
  justify-content: center;
}

.nav-menu {
  border-bottom: none !important;
}

.el-menu-item {
  font-size: 0.9rem;
  font-weight: 500;
  height: 40px;
  line-height: 40px;
  background-color: #efe6e1 !important;
  margin: 0 0.2rem;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid var(--accent-color) !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  background-color: #e8e0db !important;
}

.nav-menu ::v-deep .el-menu-item:last-child {
  background-color: var(--accent-color) !important;
}

.nav-menu ::v-deep .el-menu-item:last-child a {
  color: white !important;
}

@media (max-width: 768px) {
  .header {
    flex-direction: column;
    padding: 0.5rem 0;
  }

  .logo {
    font-size: 1.5rem;
    text-align: center;
  }

  .nav-menu {
    flex-wrap: wrap;
  }

  .el-menu-item {
    padding: 0 10px;
  }
}
</style>
